/**
 * Unified German EUR formatting: "0,00 €"
 * - Euro after amount
 * - Non-breaking space before €
 * - No "EUR" suffix, no leading €
 *
 * Prefer: formatMoneyDE(cents) or window.Kl24EuroFormat.formatMoneyDE(cents)
 */
(function () {
  const NBSP = '\u00A0';

  const formatMoneyDE = (cents) => {
    const value = Math.max(0, Number(cents) || 0) / 100;
    const amount = new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
    return `${amount}${NBSP}€`;
  };

  /** Normalize any formatted money string into "0,00 €". */
  const tightenEuro = (formatted) => {
    let s = String(formatted || '').trim();
    if (!s) return formatMoneyDE(0);
    s = s
      .replace(/\s*EUR\s*$/i, '')
      .replace(/^€\s*/, '')
      .replace(/\s*€\s*$/g, '')
      .replace(/\u00A0/g, ' ')
      .trim();
    // Keep digits/separators only for re-format when possible
    const normalized = s.replace(/\./g, '').replace(',', '.');
    const num = Number(normalized);
    if (Number.isFinite(num)) return formatMoneyDE(Math.round(num * 100));
    return `${s}${NBSP}€`;
  };

  const formatFromNumber = (amount) => formatMoneyDE(Math.round((Number(amount) || 0) * 100));
  const formatFromCents = (cents) => formatMoneyDE(cents);

  window.formatMoneyDE = formatMoneyDE;
  window.Kl24EuroFormat = {
    formatMoneyDE,
    formatCents: formatMoneyDE,
    formatFromCents,
    formatFromNumber,
    tightenEuro,
    withEuroSpace: tightenEuro,
  };
})();
